import React, { useState } from "react";
import LoginForm from "./LoginForm";
import { login } from "../../api/accounts/accountApi";

export function LoginPage() {
  const [submitting, setSubmitting] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  async function handleLogin(event: any) {
    event.preventDefault();
    // if (!formIsValid()) return;

    setSubmitting(true);

    try {
      await login(username, password);

      window.location.href = "/";
      localStorage.setItem("userAuthorized", "true");
    } catch (error: any) {
      setSubmitting(false);
      setErrors({ onLogin: error.message });
    }

    try {
    } catch (error) {}
  }

  function formIsValid() {
    const errors = {
      username,
      password,
    };

    if (!username) errors.username = "Email is required.";

    if (!password) errors.password = "Password is required";

    setErrors(errors);

    return Object.keys(errors).length === 0;
  }

  function handleEmailChange(event: any) {
    const { value } = event.target;
    setUsername(value);
  }

  function handlePasswordChange(event: any) {
    const { value } = event.target;
    setPassword(value);
  }

  return (
    <div className="transition duration-300 transition duration-300">
      <LoginForm
        passwordChange={handlePasswordChange}
        errors={errors}
        username={username}
        password={password}
        usernameChange={handleEmailChange}
        onLogin={handleLogin}
        submitting={submitting}
      />
    </div>
  );
}

export default LoginPage;
